import React, { useState, useContext } from "react";

export const MessagesContext = React.createContext({});
export const useMessages = () => useContext(MessagesContext);

export const MessagesProvider = ({ children }) => {
  const [toast, setToast] = useState({ display: false, title: '', description: '', template: '' });

  const showToast = (title, description, template) => {
    if (toast.display) {
      // HACK: trigger state change if the toast has been shown
      setToast({ display: false });

      console.log('showing toast...');

      setTimeout(() => {
        setToast({ display: true, title: title, description: description, template: template });
      }, 50);

    } else {
      setToast({ display: true, title: title, description: description, template: template });
    }
  }

  const hideToast = () => {
    setToast({ ...toast, display: false });
  }

  return (
    <MessagesContext.Provider
      value={{
        toast,
        showToast,
        hideToast,
      }}>
      {children}
    </MessagesContext.Provider>
  );
}